export default "__VITE_ASSET__DH_Z3byC__"